var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, BLACK_600, BLACK_700, Button, Card, DynamicSvg, getTestId, isValidObject, Typography } from '@airtel/air-design-system';
import { Pressable, View } from 'react-native';
import { IconButtonGroupWidget } from '../icon-button-group-widget';
import { TrustMarkerWidget } from '../trust-marker-widget';
import { getQuickActionsCardWidgetStyles } from './QuickActionsCardWidgetStyles';
export var QuickActionsCardWidgetComponent = props => {
  var quickActionsCardWidgetStyles = getQuickActionsCardWidgetStyles(props);
  var _props$id = props.id,
    id = _props$id === void 0 ? '' : _props$id,
    _props$heading = props.heading,
    heading = _props$heading === void 0 ? '' : _props$heading,
    data = props.data,
    ctaAction = props.ctaAction,
    style = props.style,
    headingStyle = props.headingStyle,
    onUserAction = props.onUserAction,
    _props$withNoCard = props.withNoCard,
    withNoCard = _props$withNoCard === void 0 ? false : _props$withNoCard,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'QuickActionsCardWidget' : _props$testID,
    _props$withChips = props.withChips,
    withChips = _props$withChips === void 0 ? false : _props$withChips,
    chipsProps = props.chipsProps,
    _props$withTrustMarke = props.withTrustMarker,
    withTrustMarker = _props$withTrustMarke === void 0 ? false : _props$withTrustMarke,
    trustMarkerProps = props.trustMarkerProps,
    headingProps = props.headingProps,
    restProps = __rest(props, ["id", "heading", "data", "ctaAction", "style", "headingStyle", "onUserAction", "withNoCard", "testID", "withChips", "chipsProps", "withTrustMarker", "trustMarkerProps", "headingProps"]);
  var _ref = ctaAction || {},
    _ref$iconName = _ref.iconName,
    iconName = _ref$iconName === void 0 ? 'MoreIcon' : _ref$iconName,
    _ref$iconProps = _ref.iconProps,
    iconProps = _ref$iconProps === void 0 ? {} : _ref$iconProps,
    text = _ref.text,
    onPress = _ref.onPress,
    ctaActionProps = _ref.ctaActionProps;
  var onCtaActionPress = () => {
    onPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onPress), props));
  };
  var onChipPress = item => {
    item.onPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, item.onPressMetaData), item));
  };
  var ctaIconProps = Object.assign({
    color: BLACK_600
  }, iconProps);
  var noCardProps = {
    noPadding: true,
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    withRoundedBorder: false,
    showShadow: false
  };
  return _jsxs(Card, Object.assign({
    style: style
  }, withNoCard && noCardProps, getTestId(testID), restProps, {
    children: [(!!heading || isValidObject(ctaAction)) && _jsxs(View, Object.assign({
      style: [quickActionsCardWidgetStyles.innerContainer, headingStyle]
    }, {
      children: [!!heading && _jsx(Typography, Object.assign({
        type: "body-single-line-xs-bold",
        text: heading,
        color: BLACK_700
      }, headingProps)), isValidObject(ctaAction) && ((text === null || text === void 0 ? void 0 : text.length) > 0 ? _jsx(Button, Object.assign({
        buttonType: "tertiary",
        size: "sm",
        onPress: onCtaActionPress,
        title: text
      }, ctaActionProps)) : _jsx(Pressable, Object.assign({
        onPress: onCtaActionPress
      }, {
        children: _jsx(DynamicSvg, Object.assign({
          iconName: iconName
        }, ctaIconProps))
      })))]
    })), !!(data === null || data === void 0 ? void 0 : data.length) && _jsx(IconButtonGroupWidget, Object.assign({}, getTestId(testID), {
      data: data
    }, restProps, {
      onUserAction: onUserAction
    })), withChips && isValidObject(chipsProps) && _jsx(View, Object.assign({
      style: [quickActionsCardWidgetStyles.chipContainer]
    }, {
      children: chipsProps.map(item => {
        return _jsx(Badge, Object.assign({}, item, {
          prefixIconProps: Object.assign({
            fontSize: 20
          }, item.prefixIconProps),
          onPress: () => {
            onChipPress(item);
          }
        }));
      })
    })), withTrustMarker && isValidObject(trustMarkerProps) && _jsx(TrustMarkerWidget, Object.assign({}, trustMarkerProps, {
      style: [quickActionsCardWidgetStyles.trustMarker, trustMarkerProps.style]
    }))]
  }));
};
QuickActionsCardWidgetComponent.genericRendererKey = 'AirQuickActionsCardWidget';